import React from 'react';
import { TreeDeciduous, Camera, Users, MessageCircle } from 'lucide-react';

const FEATURES = [
  {
    icon: TreeDeciduous,
    title: 'Build Your Living Family',
    desc: 'Add parents, partners, siblings, children, in-laws, step-family and chosen family — every relationship belongs.',
    accent: 'from-fuchsia-500 to-pink-500',
  },
  {
    icon: Camera,
    title: 'Preserve Your Family Story',
    desc: 'Photos, videos, voice notes, and private family conversations tied to the people and moments they belong to — your shared family timeline.',
    accent: 'from-purple-500 to-fuchsia-500',
  },
  {
    icon: Users,
    title: 'Stay Connected, Together',
    desc: 'Invite anyone in your family network, start private family conversations, and watch your shared space grow across households and generations.',
    accent: 'from-rose-500 to-purple-600',
  },
  {
    icon: MessageCircle,
    title: 'Private Family Messaging',
    desc: 'Talk one-to-one or as a family group inside your private KinsCircle space — no public posting, no email thread required.',
    accent: 'from-fuchsia-500 to-purple-600',
  },
];

const CoreFeatures: React.FC = () => {
  return (
    <section className="bg-white py-20 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs uppercase tracking-[0.2em] text-fuchsia-600 font-semibold mb-3">
            Your family operating system
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
            Three ways KinsCircle keeps your family close.
          </h2>
        </div>


        <div className="grid md:grid-cols-3 gap-6">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="group relative rounded-3xl p-8 bg-gradient-to-b from-pink-50/60 to-white border border-pink-100 hover:border-fuchsia-200 hover:shadow-xl transition-all duration-300"
            >
              <div
                className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${f.accent} flex items-center justify-center shadow-lg shadow-fuchsia-500/20 mb-6`}
              >
                <f.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-slate-900 mb-2.5">
                {f.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreFeatures;
